import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import '../../index.css';

const Layout = () => {
  return (
    <div className="main-container">
      <Header />

      <div className="content-wrapper">
        <main className="main-content">
          <div className="content-scrollable">
            <div className="content-padding">
              <Outlet />
            </div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default Layout;
